<template>
  <div>
    <v-tabs>
      <v-tab href="#tab-1">Not Exist</v-tab>
      <v-tab href="#tab-2">Exist</v-tab>
      <v-spacer></v-spacer>
      <add-repair-item
        :isAllTextFieldDisable="isAllTextFieldDisable"
        :isAcceptance="isAcceptance"
        :isDone="isDone"
      />
      <v-tab-item value="tab-1">
        <v-card flat>
          <repair-item-not-in-resume
            :titleName="'acceptance_item_not_in_resume_title'"
            :repairItemsNotInResume="repairItemsNotInResume"
            :isAllTextFieldDisable="isAllTextFieldDisable"
            :isAcceptance="isAcceptance"
            :isDone="isDone"
            @setEditedRepairItemIndex="setEditedRepairItemIndex"
            @setEditedRemoveRepairItemNotInResume="setEditedNotExistRemoveRepairItem"
            @setDeleteItem="setDeleteNotExistRemoveRepairItem"
            @setItemIsNeedThrowResume="setRepairItemIsNeedThrowResume"
          />
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <v-card flat>
          <repair-item-in-resume
            :titleName="'acceptance_item_in_resume_title'"
            :repairItemsInResume="repairItemsInResume"
            :isAllTextFieldDisable="isAllTextFieldDisable"
            :isAcceptance="isAcceptance"
            :isDone="isDone"
            @setEditedRepairItemIndex="setEditedRepairItemIndex"
            @setEditedRemoveRepairItemInResume="setEditedExistRemoveRepairItem"
            @setDeleteItem="setDeleteExistRemoveRepairItem"
          />
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import RepairItemInResume from '@/components/Repair/RepairItemInResume.vue'
import RepairItemNotInResume from '@/components/Repair/RepairItemNotInResume.vue'
import AddRepairItem from './AddRepairItem.vue'
export default {
  components: { RepairItemInResume, RepairItemNotInResume, AddRepairItem },
  name: 'RepairItem',
  props: {
    repairItemsInResume: {
      type: Array,
      default () {
        return []
      }
    },
    repairItemsNotInResume: {
      type: Array,
      default () {
        return []
      }
    },
    isDone: {
      type: Boolean,
      default: false
    },
    isAcceptance: {
      type: Boolean,
      default: false
    },
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    editedRepairItemIndex: -1
  }),
  computed: {},
  methods: {
    setDeleteNotExistRemoveRepairItem (val) {
      this.$emit('setDeleteNotExistRemoveRepairItem', val)
    },
    setDeleteExistRemoveRepairItem (val) {
      this.$emit('setDeleteExistRemoveRepairItem', val)
    },
    setEditedNotExistRemoveRepairItem (val) {
      this.$emit('setEditedRepairItemIndex', this.editedRepairItemIndex)
      this.$emit('setEditedRemoveRepairItemNotInResume', val)
    },
    setEditedRepairItemIndex (val) {
      this.editedRepairItemIndex = val
    },
    setEditedExistRemoveRepairItem (val) {
      this.$emit('setEditedRepairItemIndex', this.editedRepairItemIndex)
      this.$emit('setEditedRemoveRepairItemInResume', val)
    },
    setRepairItemIsNeedThrowResume (temp) {
      this.$emit('setRepairItemIsNeedThrowResume', temp)
    }
  }
}
</script>
